import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateInvoiceConfig } from 'api/invoiceConfig/updateInvoiceConfig'
import { invoiceConfigKey } from './keys'

export const useEditInvoiceConfigMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof updateInvoiceConfig>[0]) =>
      updateInvoiceConfig(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invoiceConfigKey })
    },
  })
}
